module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Hb-Ib.ffdb82ee.png";